import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import { TooltipsService } from '../../services/tooltips.service';
import './product-offering-slider-exchange.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var ProductOfferingSliderExchange = /** @class */ (function (_super) {
    tslib_1.__extends(ProductOfferingSliderExchange, _super);
    function ProductOfferingSliderExchange(element) {
        return _super.call(this, element) || this;
    }
    ProductOfferingSliderExchange.prototype.init = function () {
        this.productContainer = $('.product-card-wrapper');
        this.endpoint = this.element.getAttribute('data-endpoint');
        this.producttype = $("div.component.product-offering-slider-exchange").attr('data-producttype');
        if (this.producttype) {
            this.producttype = this.producttype.toLowerCase();
        }
        this.getProducts();
    };
    ProductOfferingSliderExchange.prototype.bindEvents = function () {
        var _this = this;
        window.addEventListener('resize', this.debounce(function () {
            _this.normalizeCardHeight();
        }, 50, false));
    };
    ProductOfferingSliderExchange.prototype.animate = function () {
    };
    ProductOfferingSliderExchange.prototype.getProducts = function () {
        var _this = this;
        var parseData = sliderJsonData;
        this.filterJson = parseData.filters;
        this.productJson = parseData.products;
        this.comparable = _.some(this.productJson, function (product) {
            return product.comparable;
        });
        var docfragment = document.createDocumentFragment();
        this.productJson.forEach(function (card) {
            docfragment.appendChild(_this.renderProduct(card));
        });
        this.productContainer[0].appendChild(docfragment);
        TooltipsService.initTooltips();
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        setTimeout(function () {
            _this.initSlider();
            _this.normalizeCardHeight();
        }, 500);
    };
    ProductOfferingSliderExchange.prototype.initSlider = function () {
        this.sliderConfig = {
            slidesPerView: 2,
            spaceBetween: 35,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 1.8,
                    spaceBetween: 35,
                },
                768: {
                    initialSlide: 0,
                    slidesPerView: 1.5,
                    spaceBetween: 20,
                },
                576: {
                    initialSlide: 0,
                    slidesPerView: 1.2,
                    spaceBetween: 15,
                }
            },
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev,
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    ProductOfferingSliderExchange.prototype.normalizeCardHeight = function () {
        if ($(window).width() < 951) {
            $('.product-card__content').css('min-height', "initial");
            $('.product-card__content > p').css('min-height', "initial");
        }
        else {
            var highestContent_1 = 0;
            $('.product-card__content').each(function (index, el) {
                var contentHeight = $(el).outerHeight();
                if (highestContent_1 < contentHeight) {
                    highestContent_1 = contentHeight;
                }
            });
            $('.product-card__content').css('min-height', highestContent_1 + "px");
            var highestParagragh_1 = 0;
            $('.product-card__content > p').each(function (index, el) {
                var paragraphHeight = $(el).height();
                if (highestParagragh_1 < paragraphHeight) {
                    highestParagragh_1 = paragraphHeight;
                }
            });
            $('.product-card__content > p').css('min-height', highestParagragh_1 + "px");
            var highestTerms_1 = 0;
            $('.product-card__terms').each(function (index, el) {
                var termHeight = $(el).height();
                if (highestTerms_1 < termHeight) {
                    highestTerms_1 = termHeight;
                }
            });
            $('.product-card__terms').css('min-height', highestTerms_1 + "px");
        }
    };
    ProductOfferingSliderExchange.prototype.renderProduct = function (input) {
        var _this = this;
        var productPrices = "";
        var productTags = "";
        var productButtons = "";
        var productTerms = "";
        var termCount = 0;
        input.pricing.forEach(function (price) {
            if (price.symbol === 'GBP' || price.symbol === undefined) {
                if (price.terms) {
                    termCount++;
                    var asterix = '';
                    for (var index = 0; index < termCount; index++) {
                        asterix += '*';
                    }
                    productTerms += "\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<span class=\"title title--asterisk\">" + asterix + "</span>\n\t\t\t\t\t\t\t<span>" + price.terms + "</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t";
                }
                productPrices += _this.renderProductPrice(price, termCount);
            }
        });
        input.tags.forEach(function (tag) {
            productTags += " " + tag.replace(/ /g, "-");
        });
        var btnCount = 0;
        input.buttons.forEach(function (btn) {
            productButtons += _this.renderButtons(btn, btnCount, input);
            btnCount++;
        });
        productTerms = "\n\t\t\t<div class=\"product-card__terms\">\n\n\t\t\t\t" + productTerms + "\n\n\t\t\t</div>";
        var output = "";
        output += "<div class=\"product-card product-card__image swiper-slide " + productTags.toLowerCase() + "\" data-id=\"" + input.id + "\">";
        if (input.onPromotion) {
            output += "<div class=\"feature-badge\">\n\t\t\t\t" + input.promotionLabel + "\n\t\t\t</div>";
        }
        if (input.cardImage) {
            output += "<img class=\"product-card__image--card\" src=\"" + input.cardImage + "\">";
        }
        output += "\n\t\t<div class=\"product-card__outer\">\n\t\t\t<div class=\"product-card__inner\" data-trackingregion=\"product offering " + this.producttype + (" > " + input.title.toLowerCase() + "\">\n\t\t\t\t<div class=\"product-card__content\">        \n\t\t\t\t\n\t\t\t\t\t<div class=\"product-card__title title title--module-sub-title\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class=\"title-gradient title-gradient--product\"></div>\n\t\t\t\t\t\n\t\t\t\t\t<p>" + input.subTitle + "</p>\n\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t" + productPrices + "\n\t\t\t\t\t</div>\t\t\t\t\n\n\t\t\t\t</div>");
        //card buttons
        output += "\n\t\t\t<div class=\"product-card__buttons\">\t\t\n\t\t\n\t\t\t\t<div class=\"row\">\t\t\n\t\t\n\t\t\t\t\t<div class=\"col-12\">\n                    \n\t\t\t\t\t" + productTerms + "\n\t\t\t\t\t\n\t\t\t\t\t<div class=\"float-md-right float-sm-left\">\t\t\t\t\t\n\t\t\n\t\t";
        output += "\n                            <div class=\"" + (this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder product-card__compare-placeholder--sml') + "\"></div>\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t" + productButtons + "\n\n\t\t\t\t</div>\n\n\t\t\t</div>";
        //end card buttons
        output += "</div>"; //inner close
        output += "</div>"; //outer close
        output += "</div>"; //main close
        return document.createRange().createContextualFragment(output);
    };
    ProductOfferingSliderExchange.prototype.renderButtons = function (input, index, product) {
        var output = "";
        // Analytics - included the product in the param lis so we can get the prod name
        var productTitle = product.title ? product.title : "<<product name>>";
        var dataIntent = 'Informational';
        if (input.buttonClass) {
            var dataButtonClass = input.buttonClass.toLowerCase();
            if (dataButtonClass === 'eligibility') {
                dataIntent = 'Transactional';
            }
            else if (dataButtonClass === 'callmeback') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'apply') {
                dataIntent = 'Transactional';
            }
            else if (dataButtonClass === 'contactus') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'contact us') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'contact') {
                dataIntent = 'Query';
            }
            else if (dataButtonClass === 'productdetails') {
                dataIntent = 'Informational';
            }
            else if (dataButtonClass === 'compare') {
                dataIntent = 'Comparison;';
            }
            else if (dataButtonClass === 'salesforceapplynow') {
                dataIntent = 'Transactional';
            }
        }
        if (input.buttonClass === 'ProductDetails') {
            if (input.isModal) {
                output += "\n\t\t\t\t<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">\n\t\t\t\t\t<a class=\"button button--main js-apply-now-modal-open\"\n\t\t\t\t\t\thref=\"#\"\n\t\t\t\t\t\ttarget=\"\"\n\t\t\t\t\t\tdata-modal=\"apply-now-modal-" + input.modalId + "\"\n\t\t\t\t\t\tdata-intent=\"" + dataIntent + "\"\n\t\t\t\t\t\tdata-scope=\"productOfferingSliderExchange\"\n\t\t\t\t\t\tdata-id=\"link_content_product offering\"\n\t\t\t\t\t\tdata-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">\n\t\n\t\t\t\t\t\t" + input.title + "\n\t\n\t\t\t\t\t</a>\n\t\t\t\t</div>\n\t\t\t\t");
            }
            else {
                output += "\n\t\t\t\t\t<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">\n\t\t\t\t\t\t<a class=\"button button--main " + (index === 0 ? '' : 'button--white button--border-blue') + "\"\n\t\t\t\t\t\t\thref=\"" + input.url + "\"\n\t\t\t\t\t\t\ttarget=\"" + input.target + "\"\n\t\t\t\t\t\t\tdata-intent=\"" + dataIntent + "\"\n\t\t\t\t\t\t\tdata-scope=\"productOfferingSliderExchange\"\n\t\t\t\t\t\t\tdata-id=\"link_content_product offering\"\n\t\t\t\t\t\t\tdata-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">\n\t\n\t\t\t\t\t\t\t" + input.title + "\n\t\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</div>\n\t\t\t\t");
            }
        }
        return output;
    };
    ProductOfferingSliderExchange.prototype.renderProductPrice = function (input, termCount) {
        if (input.symbol) {
            var currencySymbol = this.symbol(input.symbol);
        }
        var output = "";
        output += "<div class=\"product-card__price col-6 col-xs-6 col-sm-6\">";
        if (input.symbol && input.symbol.toLowerCase() == 'r') {
            output += "\n\t\t\t\t<span class=\"title title--initial title--currency\">\n\t\t\t\t\t" + currencySymbol.symbol + "\n\t\t\t\t</span>\n\t\t\t";
        }
        if (input.symbol && input.symbol.toLowerCase() != 'r') {
            output += "\n\t\t\t\t<span class=\"title title--initial title--currency\">\n\t\t\t\t\t" + currencySymbol.symbol + "\n\t\t\t\t</span>\n\t\t\t";
        }
        if (input.note) {
            output += "\n\t\t\t\t<span class=\"title title--initial product-card__price__note\">\n\t\t\t\t\t" + input.title + "\n\t\t\t\t</span>\n\t\t\t";
        }
        else if (input.subTitle == "Supported currencies") {
            var supportedCurrencies = input.title.split(',');
            var supportedCurrenciesString = "";
            var supportedCurrenciesTooltip = "";
            if (supportedCurrencies.length <= 5) {
                for (var index = 0; index < supportedCurrencies.length; index++) {
                    if (index == 0) {
                        supportedCurrenciesString += supportedCurrencies[index];
                    }
                    else {
                        supportedCurrenciesString += ", " + supportedCurrencies[index];
                    }
                }
            }
            else if (supportedCurrencies.length > 5) {
                for (var index = 0; index < 5; index++) {
                    if (index == 0) {
                        supportedCurrenciesString += supportedCurrencies[index];
                    }
                    else {
                        supportedCurrenciesString += ", " + supportedCurrencies[index];
                    }
                }
                supportedCurrenciesString += ", Other";
                for (var index = 5; index < supportedCurrencies.length; index++) {
                    if (index == 5) {
                        supportedCurrenciesTooltip += "SUPPORTED CURRENCIES:<br>" + supportedCurrencies[index];
                    }
                    else {
                        supportedCurrenciesTooltip += ", " + supportedCurrencies[index];
                    }
                }
                supportedCurrenciesString += "\n\t\t\t\t<span title=\"" + supportedCurrenciesTooltip + "\" data-title=\"" + supportedCurrenciesTooltip + "\">\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-tooltip\" class=\"icon \"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\t\t\t\t</span>\n\t\t\t\t";
            }
            output += "\n\t\t\t\t<span class=\"title title--initial title--number product-offering-slider-exchange__pricing-title--small product-offering-slider-exchange__pricing-title--supportedcurrencies\" style=\"display: flex !important;\">\n\t\t\t\t\t" + supportedCurrenciesString + "\n\t\t\t\t</span>\n\t\t\t";
        }
        else {
            if (termCount <= 7) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--number\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            else if (termCount >= 8 && termCount < 16) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--number product-offering-slider-exchange__pricing-title--medium\" style=\"display: flex !important;\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            else {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--number product-offering-slider-exchange__pricing-title--small\" style=\"display: flex !important;\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
        }
        if (input.tooltip) {
            output += "\n\t\t\t\t<span title=\"" + input.tooltip + "\" data-title=\"" + input.tooltip + "\">\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-tooltip\" class=\"icon \"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\t\t\t\t</span>\n\t\t\t";
        }
        if (input.terms) {
            var asterix = '';
            for (var index = 0; index < termCount; index++) {
                asterix += '*';
            }
            output += "\n\t\t\t\t<span class=\"title title--initial title--asterisk\">" + asterix + "</span>\n\t\t\t";
        }
        if (input.strike) {
            output += "\n\t\t\t\t<div class=\"title title--initial title--number-strike\">\n\t\t\t\t\t<span class=\"title title--number-striker\"></span>\n\t\t\t";
            if (input.symbol) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--currency-sml\">\n\t\t\t\t\t\t" + currencySymbol.symbol + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            output += "\n\t\t\t\t\t<span class=\"title title--initial title--number-sml\">\n\t\t\t\t\t\t" + input.strike + "\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t";
        }
        output += "\n\t\t\t<div class=\"title title--notes\">\n\t\t\t\t" + input.subTitle + "\n\t\t\t</div>\t\n\t\t";
        output += "</div>"; //main close
        return output;
    };
    ProductOfferingSliderExchange.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    ProductOfferingSliderExchange.prototype.symbol = function (value) {
        var key = value;
        key = key.trim().split(' ').join('').toUpperCase();
        switch (key) {
            case "GBP":
                return {
                    title: "GBP",
                    symbolName: "GBP",
                    symbol: "£",
                    image: "/file_source/assets/icons/flag-united-kingdom.svg"
                };
                break;
            case "USD":
                return {
                    title: "USD",
                    symbolName: "USD",
                    symbol: "$",
                    image: "/file_source/assets/icons/flag-united-states.svg"
                };
                break;
            case "ZAR":
                return {
                    title: "ZAR",
                    symbolName: "ZAR",
                    symbol: "R",
                    image: "/file_source/assets/icons/flag-south-africa.svg"
                };
                break;
            case "AUD":
                return {
                    title: "AUD",
                    symbolName: "AUD",
                    symbol: "AU$",
                    image: "/file_source/assets/icons/flag-australia.svg"
                };
                break;
            case "EUR":
                return {
                    title: "EURO",
                    symbolName: "EUR",
                    symbol: "€",
                    image: "/file_source/assets/icons/flag-euro.svg"
                };
                break;
            case "OTHER":
                return {
                    title: "OTHER",
                    symbolName: "OTHER",
                    symbol: "",
                    image: "/file_source/assets/icons/flag-global.svg"
                };
                break;
            default:
                break;
        }
    };
    return ProductOfferingSliderExchange;
}(Base));
export { ProductOfferingSliderExchange };



//////////////////
// WEBPACK FOOTER
// ./components/product-offering-slider-exchange/product-offering-slider-exchange.component.ts
// module id = 454
// module chunks = 0